import { getCSSVariable } from "../../helpers/css-util.js";
import AbstractChartStrategy from "./AbstractChartStrategy.js";

/**
 * Implement a Strategy to render a stacked barplot
 *
 * @param {object[]} values - Data serie with its label, its values,
 *  and a color to fill the bar with
 * @param {number} yAxisMax - Max for ordinate scale, used to render
 *  graphs comparable
 */
export default class StackedBarplotChartStrategy extends AbstractChartStrategy {
	constructor({ yAxisMax }) {
		super(...arguments);

		this._yAxisMax = yAxisMax;
	}

	_makeDatasets({ values: dataSeries }) {
		const barThickness = getCSSVariable(
			"--stacked-bar-chart-thickness-in-px",
		);

		return dataSeries.map((values) => ({
			label: values.label,
			data: values.data,
			backgroundColor: values.fillColor,
			stack: values.stack,
			barThickness,
			borderWidth: 1.5,
			borderColor: "white",
		}));
	}

	_getChartType() {
		return "bar";
	}

	_getChartOptions() {
		return {
			...super._getChartOptions(),
			scales: {
				x: { display: false, stacked: true },
				y: { display: false, stacked: true, max: this._yAxisMax },
			},
			plugins: {
				tooltip: {
					yAlign: "bottom",
				},
			},
		};
	}
}
